import React, { useEffect, useState } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getRecords } from "../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { LoaderCreatePage } from "../Loader/Loader.js";
import CourierInvoiceDetails from "./CourierInvoiceDetails.js";
import { createPageData, listPageData } from "./CourierFile.js";

const CourierView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { navigatePage, invoiceViewEndpoint } = createPageData();
  const { navigatePage: listNavigatePage } = listPageData();

  const [loadingData, setLoadingData] = useState(Boolean(id));
  const [invoiceDetails, setInvoiceDetails] = useState(null);

  useEffect(() => {
    if (id) getCourierData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getCourierData = async (invoiceId) => {
    try {
      const responseData = await getRecords(
        { invoice_id: invoiceId },
        invoiceViewEndpoint,
      );
      if (responseData?.data) setInvoiceDetails(responseData.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <div className="card mt-4">
                      <div className="card-header d-flex align-items-center">
                        <h5 className="mb-0">Courier Details</h5>
                        <div className="ms-auto d-flex gap-2">
                          <Button
                            color="primary"
                            className="waves-effect waves-light"
                            onClick={() =>
                              navigate(`${listNavigatePage?.edit}/${id}`)
                            }
                          >
                            Edit
                          </Button>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                      </div>

                      <div className="card-body">
                        <CourierInvoiceDetails
                          invoice={invoiceDetails?.invoice}
                          dispatches={invoiceDetails?.dispatches}
                          showCourier={true}
                        />
                      </div>
                    </div>

                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CourierView;
